var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 16,
    height: 8,
    rx: 2,
    fill: "#DAC6E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.10938L3 18.8906C3 20.0537 3.94814 21 5.11355 21L8.88645 21C10.0519 21 11 20.0537 11 18.8906L11 5.10937C11 3.94627 10.0519 3 8.88645 3L5.11355 3C3.94814 3 3 3.94627 3 5.10938ZM8.88645 4.40625C9.27492 4.40625 9.59097 4.72167 9.59097 5.10937L9.59097 18.8906C9.59097 19.2783 9.27492 19.5937 8.88645 19.5937L5.11355 19.5937C4.72508 19.5937 4.40903 19.2783 4.40903 18.8906L4.40903 5.10937C4.40903 4.72167 4.72508 4.40625 5.11355 4.40625L8.88645 4.40625Z",
    fill: "#272932"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0156 5.10938L13.0156 18.8906C13.0156 20.0537 13.9638 21 15.1292 21L18.9021 21C20.0675 21 21.0156 20.0537 21.0156 18.8906L21.0156 5.10937C21.0156 3.94627 20.0675 3 18.9021 3L15.1292 3C13.9638 3 13.0156 3.94627 13.0156 5.10938ZM18.9021 4.40625C19.2905 4.40625 19.6066 4.72167 19.6066 5.10937L19.6066 18.8906C19.6066 19.2783 19.2905 19.5937 18.9021 19.5937L15.1292 19.5937C14.7407 19.5937 14.4247 19.2783 14.4247 18.8906L14.4247 5.10937C14.4247 4.72167 14.7407 4.40625 15.1292 4.40625L18.9021 4.40625Z",
    fill: "#272932"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumn);
export default __webpack_public_path__ + "static/media/Column.48f06f0655fa2e1bb3dec54624d95931.svg";
export { ForwardRef as ReactComponent };